export default __webpack_public_path__ + "static/media/misc-pantry2-1920w.41826771.avif";